import { Navigate, Outlet } from 'react-router-dom'
import { useGetSiteCurrentuserQuery } from '../api'
import { useAppSelector } from '../store/hooks/Redux'
import { Preloader } from '../../shared/components/cards/preloader/Preloader'
import { selectAuthenticated } from '../store/reducers/AuthSlice'
import { useEffect } from 'react'

export const MainGuard = () => {
  const { isLoading, isFetching, refetch } = useGetSiteCurrentuserQuery(undefined, {
    skip: false,
    refetchOnMountOrArgChange: true,
    pollingInterval: 309000,
  })

  const authenticated = useAppSelector(selectAuthenticated)
  const loading = isLoading || isFetching

  useEffect(() => {
    setInterval(() => refetch(), 60 * 1000)
  }, [])

  if ((loading && authenticated == null) || authenticated == null) {
    return <Preloader />
  }

  return authenticated ? <Outlet /> : <Navigate to='/auth' />
}
